import { UserStore } from './../state/user.store';
import { DEVICE_TYPE, DOCUMENT_STATUS, DOCUMENT_TYPE } from '../models/User';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../models/User';
import { IFiatDeposit, IFiatTransaction } from '../models/FiatTransaction';
import { Observable } from 'rxjs';
import { ISuccessLogin } from '../models/Auth';
import { HttpResponse } from '@angular/common/http';
import {
  BANK_CODE_NEQUI,
  DOCUMENT_TYPE_PHL,
  EXCHANGE,
  EXCHANGE_COUNTRY,
  exchangeToExchangeCountry,
  LEGAL_ID_TYPE,
  OnboardingState,
  PAYMENT_METHOD,
} from '../models/Onboarding';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from '../services/api.service';
import {
  IBankAccount,
  IDataWidget,
  IFieldsPersonalData,
  Status,
  STATUS_WIDGET_USER,
} from '../models/WidgetUser';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';
import { Utils } from '../utils/Utils';

enum DNI_TYPE {
  FRONT = 'front',
  BACK = 'back',
  BOTH = 'both',
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    public router: Router,
    private userState: UserStore,
    private dialog: MatDialog,
    private api: ApiService,
  ) {}

  // REFERRAL

  get loggedUserObs() {
    return this.userState.loggedUserObs;
  }

  get widgetUserObs() {
    return this.userState.widgetUserObs;
  }

  get myCryptoPortfolio() {
    return this.userState.myCryptoPortfolio;
  }

  get isMarketClosed() {
    return this.userState.isMarketClosed;
  }

  get onboardingState() {
    const obs = this.userState.onboardingState;

    obs.subscribe((data) => {
      if (data) localStorage.setItem('onboarding-data', JSON.stringify(data));
    });

    return obs;
  }

  get infoUserTerroristObs() {
    return this.userState.infoUserTerroristObs;
  }

  get newFlowOnboarding() {
    return this.userState.newFlowOnboarding;
  }

  get changeBankAccount() {
    return this.userState.changeBankAccount;
  }

  get resolveCallTruora() {
    return this.userState.resolveCallTruora;
  }

  get balanceMiniapp() {
    return this.userState.balanceMiniapp;
  }

  get signature() {
    return this.userState.signature;
  }

  set signature(signature) {
    this.userState.signature = signature;
  }

  get redirectPath() {
    return this.userState.redirectPath;
  }

  set redirectPath(path) {
    this.userState.redirectPath = path;
  }

  patchOnboardingState(data: OnboardingState) {
    this.userState.patchOnboardingState(data);
  }

  sendTikTokPageView(url: string) {
    return this.userState.sendTikTokPageView(url);
  }

  sendTikTokEvent(
    url: string,
    quantity: number,
    currency: string,
    value: number,
    price: number,
    description: string,
  ) {
    return this.userState.sendTikTokEvent(url, quantity, currency, value, price, description);
  }

  getMe() {
    this.userState.getMe();
  }

  addAccount(
    currency: string,
    cbu: string,
    description: string,
    bankCode?: string,
    bankType?: string,
    retryFailed?: boolean,
  ) {
    const obs = this.userState.addAccount(
      currency,
      cbu,
      description,
      bankCode,
      bankType,
      retryFailed,
    );
    obs.subscribe((res) => {
      if (this.loggedUser.bankAccounts[currency][0]) this.loggedUser.bankAccounts[currency] = [];
      this.loggedUser.bankAccounts[currency].push(res);
      this.userState.loggedUserObs.next(this.loggedUser);
    });
    return obs;
  }

  addAccountWithCode(
    currency: string,
    cbu: string,
    description: string,
    bankCode?: string,
    bankType?: string,
    publicAccessHash?: string,
    accountChangeCode?: string,
  ) {
    const obs = this.userState.addAccountWithCode(
      currency,
      cbu,
      description,
      bankCode,
      bankType,
      publicAccessHash,
      accountChangeCode,
    );
    return obs;
  }

  saveAccount(currency: string, cbu: string, description: string) {
    return this.userState.addAccount(currency, cbu, description);
  }

  saveTokens(tokens: { jwtToken?: string; refreshToken?: string }) {
    this.userState.saveTokens(tokens);
  }

  getTokens(): { jwtToken: string; refreshToken: string } {
    return this.userState.getTokens();
  }

  saveUserToLocalStorage() {
    this.userState.saveUserToLocalStorage();
  }

  saveRedirectPath() {
    this.userState.saveRedirectPath();
  }

  logoutWLD() {
    this.userState.logoutWLD();
  }

  logoutWidgetUser() {
    this.userState.logoutWidgetUser();
  }

  getUserFromLS() {
    return this.userState.getUserFromLS();
  }

  getWidgetUserFromLS() {
    return this.userState.getWidgetUserFromLS();
  }

  verifyLogin2FA(
    apiUrl: string,
    token: string,
  ): Observable<{ body: ISuccessLogin; status: number } | HttpResponse<{}> | Error> {
    return this.userState.verifyLogin2FA(apiUrl, token);
  }

  checkOnboardingStatus(type: string = '') {
    if (!this.hasValidatedDNIS()) {
      if (this.haveToUploadDNIS() || this.haveMissingData()) {
        this.dialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title:
                type === 'prode' ? 'Estás muy cerca de jugar' : 'Estás muy cerca de tus cryptos',
              content:
                type === 'prode'
                  ? `Para jugar es necesario que tu cuenta esté validada. Completá tu perfil haciendo click acá.`
                  : `Para operar es necesario que tu cuenta esté validada. Completá tu perfil haciendo click acá.`,
              acceptLabel: 'Completar datos',
            },
          })
          .afterClosed()
          .subscribe((data) => {
            if (data) {
              return this.router.navigate(['/auth', 'signup']);
            }
          });
        return false;
      } else if (this.hasPendingDNIS()) {
        this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: 'Perfil completado',
            content:
              'En este momento estamos validando tu cuenta. Te avisaremos por email cuando completemos tu registro.',
          },
        });
        return false;
      }
    }
    return true;
  }

  nextOnboardingStep(noNextStepCallback?: Function) {
    const user = this.userState.loggedUser;
    if (!user?.data?.civilState) {
      this.router.navigate(['/auth', 'w-signup', 'personal-data']);
    } else if (this.hasToUpdateWork()) {
      this.router.navigate(['/auth', 'w-signup', 'data-extra']);
    } else if (this.hasToUploadPepDocuments()) {
      this.router.navigate(['/auth', 'w-signup', 'pep']);
    } else if (this.hasToUploadUIFDocuments()) {
      this.router.navigate(['/auth', 'w-signup', 'uif']);
    } else if (
      !user.bankAccounts.ARS?.length &&
      !user.bankAccounts.CLP?.length &&
      (!user.bankAccounts.COP?.length ||
        (user.bankAccounts.COP[0]?.accountType === 'P' && user.bankAccounts.COP?.length < 2) ||
        (this.onboardingState.value?.paymentMethod === PAYMENT_METHOD.BREBKEY &&
          !user.bankAccounts.COP.some((account) => account?.network === 'BREB')) ||
        (this.onboardingState.value?.paymentMethod !== PAYMENT_METHOD.BREBKEY &&
          !user.bankAccounts.COP.some((account) => account?.network !== 'BREB')) ||
        (this.onboardingState.value?.paymentMethod === PAYMENT_METHOD.NEQUI &&
          !user.bankAccounts.COP.some(
            (account) => account?.bankCode === BANK_CODE_NEQUI[0].value,
          ))) &&
      !user.bankAccounts.BRL?.length &&
      !user.bankAccounts.GTQ?.length &&
      !user.bankAccounts.CRC?.length &&
      !user.bankAccounts.PUSD?.length &&
      !user.bankAccounts.MXN?.length &&
      !user.bankAccounts.PHP?.length &&
      !this.changeBankAccount()
    ) {
      if (!user?.numberId && user?.email?.length === 42) return;
      else this.router.navigate(['/auth', 'w-signup', 'bank-info']);
    } else if (this.dniNotValidated() || this.hasToWaitValidation()) {
      if (
        [
          EXCHANGE_COUNTRY.BRA,
          EXCHANGE_COUNTRY.COL,
          EXCHANGE_COUNTRY.MEX,
          EXCHANGE_COUNTRY.CHL,
          EXCHANGE_COUNTRY.PHL,
        ].includes(user.exchangeCountry as EXCHANGE_COUNTRY)
      )
        noNextStepCallback?.();
      else this.router.navigate(['/auth', 'w-signup', 'id-photo']);
    } else {
      noNextStepCallback?.();
    }
  }

  nextStepWidget() {
    const widgetUser = this.userState.widgetUserObs.value;
    const onboardingState = this.onboardingState.value;
    let currencyExist =
      widgetUser.user?.banking?.accounts.some(
        (account) => account.currency === widgetUser.against,
      ) ||
      (!widgetUser.against && true);
    if (exchangeToExchangeCountry[widgetUser.exchange!] !== EXCHANGE_COUNTRY.ARG)
      currencyExist = true;
    if (currencyExist && widgetUser.user?.status === STATUS_WIDGET_USER.ACTIVE) {
      if (
        (onboardingState.uploadImageId || widgetUser.uploadImage) &&
        (widgetUser.user.onboarding.IDENTITY_VALIDATION.status === Status.Pending ||
          widgetUser.user.onboarding.IDENTITY_VALIDATION.status === Status.Failed ||
          widgetUser.user.onboarding.IDENTITY_VALIDATION.status === Status.InProgress)
      ) {
        this.router.navigateByUrl('onboarding/id-photo');
        return;
      }
      window.location.href = `${environment.apiManteca}/widget/next?signature=${this.onboardingState.value.signature}`;
    } else {
      if (widgetUser.user?.onboarding.SECURITY_VALIDATION.status === 'FAILED') {
        this.router.navigateByUrl('not-allow');
        return;
      }
      Utils.redirectOnboarding(
        widgetUser.user?.onboarding,
        this.router,
        widgetUser.exchange,
        currencyExist,
      );
    }
  }

  //User Status related
  hasValidatedDNIS() {
    return (
      this.loggedUser?.dnis?.front === DOCUMENT_STATUS.VALIDATED &&
      this.loggedUser?.dnis?.back === DOCUMENT_STATUS.VALIDATED
    );
  }

  hasValidatedCompanyDocuments() {
    const docs = Object.values(this.loggedUser.data?.documentation || {});
    return !docs.some((doc) => doc !== DOCUMENT_STATUS.VALIDATED);
  }

  hasValidatedDocuments() {
    if (this.isCompany()) {
      return this.hasValidatedCompanyDocuments();
    } else {
      return this.hasValidatedDNIS();
    }
  }

  hasPendingDNIS() {
    return (
      this.loggedUser?.dnis?.front === DOCUMENT_STATUS.PENDING ||
      this.loggedUser?.dnis?.back === DOCUMENT_STATUS.PENDING
    );
  }

  haveToUploadDNIS(type: string = DNI_TYPE.BOTH) {
    const needFront =
      this.loggedUser?.dnis?.front === DOCUMENT_STATUS.NOT_UPLOADED ||
      this.loggedUser?.dnis?.front === DOCUMENT_STATUS.REJECTED;
    const needBack =
      this.loggedUser?.dnis?.back === DOCUMENT_STATUS.NOT_UPLOADED ||
      this.loggedUser?.dnis?.back === DOCUMENT_STATUS.REJECTED;

    if (type === DNI_TYPE.FRONT) {
      return needFront;
    } else if (type === DNI_TYPE.BACK) {
      return needBack;
    } else if (type === DNI_TYPE.BOTH) {
      return needFront || needBack;
    }
  }

  dniNotValidated() {
    const needFront = this.loggedUser?.dnis?.front === DOCUMENT_STATUS.VALIDATED;
    const needBack = this.loggedUser?.dnis?.back === DOCUMENT_STATUS.VALIDATED;
    return !needFront || !needBack;
  }

  checkStatusDnisPhl() {
    const frontStatus = this.loggedUser?.dnis?.front;
    const backStatus = this.loggedUser?.dnis?.back;

    const bothValidated =
      frontStatus === DOCUMENT_STATUS.VALIDATED && backStatus === DOCUMENT_STATUS.VALIDATED;
    const bothPending =
      frontStatus === DOCUMENT_STATUS.PENDING && backStatus === DOCUMENT_STATUS.PENDING;

    return bothValidated || bothPending;
  }

  hasToUploadCompanyDocuments() {
    if (this.isCompany()) {
      const neededDocs = Object.values(this.loggedUser.data?.documentation || {});
      if (neededDocs.length !== 0) {
        return neededDocs.some(
          (doc) => doc !== DOCUMENT_STATUS.VALIDATED && doc !== DOCUMENT_STATUS.PENDING,
        );
      } else {
        return true;
      }
    }
    return false;
  }

  hasToWaitCompanyValidation() {
    if (this.isCompany()) {
      const neededDocs = Object.values(this.loggedUser.data?.documentation || {});
      if (neededDocs.length !== 0) {
        return neededDocs.every((doc) => doc === DOCUMENT_STATUS.PENDING);
      } else {
        return true;
      }
    }
    return false;
  }

  hasToUploadPepDocuments(): boolean {
    if (this.loggedUser?.data?.isPEP && this.loggedUser.exchangeCountry === EXCHANGE_COUNTRY.ARG) {
      return (
        this.loggedUser.data.pepDoc === undefined ||
        this.loggedUser.data.pepDoc === DOCUMENT_STATUS.NOT_UPLOADED ||
        this.loggedUser.data.pepDoc === DOCUMENT_STATUS.REJECTED
      );
    }
    return false;
  }

  hasToUploadUIFDocuments(): boolean {
    if (this.loggedUser?.data?.isUIF && this.loggedUser.exchangeCountry === EXCHANGE_COUNTRY.ARG) {
      return (
        this.loggedUser.data.uifDoc === undefined ||
        this.loggedUser.data.uifDoc === DOCUMENT_STATUS.NOT_UPLOADED ||
        this.loggedUser.data.uifDoc === DOCUMENT_STATUS.REJECTED
      );
    }
    return false;
  }

  hasToUpdateWork() {
    return (
      (!this.loggedUser?.work?.desc &&
        this.loggedUser?.dnis?.front === DOCUMENT_STATUS.VALIDATED) ||
      this.loggedUser?.work?.desc === '-'
    );
  }

  haveMissingData() {
    if (this.isCompany()) {
      return (
        !this.loggedUser ||
        !this.loggedUser.cuit ||
        !this.loggedUser.phoneNumber ||
        !this.loggedUser.data?.postalCode ||
        !this.loggedUser.bankAccounts.ARS.length
      );
    } else {
      return (
        !this.loggedUser ||
        !this.loggedUser.cuit ||
        !this.loggedUser.data?.birthDate ||
        !this.loggedUser.data?.civilState ||
        !this.loggedUser.phoneNumber ||
        !this.loggedUser.data?.postalCode ||
        !this.loggedUser.bankAccounts.ARS.length ||
        !this.loggedUser.work?.desc ||
        (this.loggedUser.work.desc === '-' && this.hasToUploadDocuments())
      );
    }
  }

  needToCompletedOnboarding() {
    if (this.isCompany()) {
      return (
        this.haveMissingData() || !this.allCompanyDocumentsUpdated() || this.hasToUploadDocuments()
      );
    } else {
      return (
        this.haveMissingData() || this.hasToUploadDocuments() || this.hasToUploadPepDocuments()
      );
    }
  }

  hasToUploadDocuments() {
    if (this.isCompany()) {
      return this.hasToUploadCompanyDocuments();
    } else {
      return this.haveToUploadDNIS();
    }
  }

  hasToWaitValidation() {
    if (this.loggedUser?.exchangeCountry !== EXCHANGE_COUNTRY.ARG) return false;
    const dnis = this.loggedUser?.dnis;
    const pep = this.loggedUser?.data?.pepDoc;
    const uif = this.loggedUser?.data?.uifDoc;
    const statuses = [dnis?.back, dnis?.front, pep, uif];
    const somePending = statuses.some((doc) => doc === DOCUMENT_STATUS.PENDING);
    const hasToUpload = statuses.some(
      (doc) => doc === DOCUMENT_STATUS.REJECTED || doc === DOCUMENT_STATUS.NOT_UPLOADED,
    );
    return somePending && !hasToUpload;
  }

  getUploadImageUrl(
    type: DOCUMENT_TYPE,
    fileName: string,
    deviceType: DEVICE_TYPE = DEVICE_TYPE.Web,
    isArbitrage = false,
    extraData?: { phlDocumentType: DOCUMENT_TYPE_PHL },
  ): Observable<{ url: string }> {
    return this.userState.getUploadImageUrl(type, fileName, deviceType, isArbitrage, extraData);
  }

  uploadImageToUrl(url: string, image: File): any {
    return this.userState.uploadImageToUrl(url, image);
  }

  getPromotionMessage() {
    return this.userState.getPromotionMessages();
  }

  // Accounts
  getAccounts(coin: number) {
    return this.userState.getAccounts(coin);
  }

  // Accounts
  getCryptoAccounts(coin: number) {
    return this.userState.getCryptoAccounts(coin);
  }

  isCompany() {
    return this.userState.isCompany();
  }

  addDepositTxToHistory(deposit: IFiatDeposit) {
    this.userState.addDepositTxToHistory(deposit);
  }

  refundWithdrawBalance(withdraw: IFiatTransaction) {
    this.userState.refundWithdrawBalance(withdraw);
  }

  setDocumentStatus(documentType: DOCUMENT_TYPE, status: DOCUMENT_STATUS) {
    this.userState.setDocumentStatus(documentType, status);
  }

  allCompanyDocumentsUpdated() {
    return this.userState.allCompanyDocumentsUpdated();
  }

  getFiatStatus() {
    return this.userState.getFiatStatus();
  }

  refreshFiatStatus() {
    return this.userState.refreshFiatStatus();
  }

  set loggedUser(user) {
    this.userState.loggedUser = user;
  }

  // Esto podría hacer referencia al store, asi logrando facade sin cambiar nada
  get loggedUser(): User {
    return this.userState.loggedUser;
  }

  getJwtWithUuid(uuid: string) {
    const obs = this.userState.getJwtWithUuid(uuid);
    obs.subscribe((resp) => {
      this.saveTokens({
        jwtToken: resp.token,
        refreshToken: resp.token,
      });
      this.getMe();
    });
    return obs;
  }

  updateCheckInfoTerrorist(value: { isTerrorist: boolean }) {
    this.userState.infoUserTerroristObs.next(value);
  }

  updateResolveCallTruora(change: boolean) {
    this.userState.resolveCallTruora.next(change);
  }

  setNewFlowOnboarding(newFlow: boolean) {
    this.userState.newFlowOnboarding.next(newFlow);
  }

  getStatusUser(signature: string) {
    const obs = this.api.getStatusUser(signature);
    obs.subscribe((resp) => {
      this.userState.setStatusUser(resp.data);
    });

    return obs;
  }

  registerUser(
    email: string,
    legalId: string,
    exchange: EXCHANGE,
    legalIdType: LEGAL_ID_TYPE,
    isPPT?: boolean,
  ) {
    const obs = this.api.registerUser(
      this.onboardingState.value.signature!,
      email,
      legalId,
      exchange,
      legalIdType,
      isPPT,
    );
    obs.subscribe((user) => {
      this.userState.setStatusUser(user, isPPT);
    });
    return obs;
  }

  updatePersonalData(fields: IFieldsPersonalData, signature: string) {
    const obs = this.api.updatePersonalData(fields, signature);
    obs.subscribe((user) => {
      this.userState.setStatusUser(user);
    });
    return obs;
  }

  addBankAccount(bankAccount: any, signature: string) {
    const obs = this.api.addBankAccount(bankAccount, signature);
    obs.subscribe((_) => {
      // this.userState.setStatusUser(user);
    });
    return obs;
  }

  addBankAccountWidgetV1(bankAccount: IBankAccount) {
    const obs = this.api.addBankAccountWidgetV1(bankAccount);
    obs.subscribe((data) => {
      // this.userState.setStatusUser(user);
      console.log('data', data);
    });
    return obs;
  }

  getDocuments(documentAnyId: string, signature: string) {
    const obs = this.api.getDocuments(documentAnyId, signature);
    return obs;
  }

  getAfipData() {
    return this.api.getAfipData();
  }

  getCuitByDniWidget(dni: string, signature: string, sex?: 'MALE' | 'FEMALE') {
    return this.api.getCuitByDniWidget(dni, signature, sex);
  }

  getPresignedUrl(
    docType: DOCUMENT_TYPE,
    filename: string,
    signature: string,
  ): Observable<{ url: string }> {
    return this.api.getPresignedUrl(docType, filename, signature);
  }

  getTruoraData(legalId: string, exchangeCountry?: EXCHANGE_COUNTRY) {
    return this.api.getTruoraData(legalId, exchangeCountry);
  }

  getUserDataBr(legalId: string) {
    return this.api.getUserDataBr(legalId);
  }

  getUserLimits() {
    const obs = this.api.getUserLimits();
    obs.subscribe();
    return obs;
  }

  setChangeBankAccount(change: boolean) {
    this.userState.setChangeBankAccount(change);
  }

  sendCodeSMS(phoneNumber: string) {
    return this.api.sendCodeSMS(phoneNumber);
  }

  confirmPhoneNumber(code: string) {
    return this.api.confirmPhoneNumber(code).pipe(
      tap(() => {
        this.getMe();
      }),
    );
  }

  setBalanceMiniapp(balance: { WLD: string; USDC: string }) {
    this.userState.setBalanceMiniapp(balance);
  }

  setStatusWidgetUser(data: IDataWidget) {
    this.userState.setStatusUser(data);
  }

  getCuitWithCbu(cbu: string) {
    const obs = this.api.getCuitWithCbu(cbu);
    obs.subscribe();
    return obs;
  }
}
